const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'modules/herbal-cms-detail-content/actions/get-cms-detail-content.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-detail-content/actions/get-cms-detail-content.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-cms-list-content-my-library/actions/get-cms-list-my-library.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-list-content-my-library/actions/get-cms-list-my-library.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-cms-list-content-news/actions/get-cms-list-content-news.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-list-content-news/actions/get-cms-list-content-news.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-cms-list-content-video/actions/get-cms-list-content-video.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-list-content-video/actions/get-cms-list-content-video.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-cms-list-content/actions/get-cms-list-content.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-list-content/actions/get-cms-list-content.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-cms-news-recent-article/actions/get-cms-news-recent-article.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-news-recent-article/actions/get-cms-news-recent-article.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-cms-news-tags/actions/get-cms-news-detail-list-tags.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-news-tags/actions/get-cms-news-detail-list-tags.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-cms-news-top-article/actions/get-cms-news-top-article.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-cms-news-top-article/actions/get-cms-news-top-article.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-dashboard-latest-news/actions/get-cms-news-recent-article.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-dashboard-latest-news/actions/get-cms-news-recent-article.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-dashboard-my-library/actions/get-cms-list-my-library-dashboard.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-dashboard-my-library/actions/get-cms-list-my-library-dashboard.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-invoices-list/actions/get-ordered-invoices.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-invoices-list/actions/get-ordered-invoices.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'modules/herbal-product-specification/actions/get-cms-product-attribute.action';
            binding.dataActions[actionPath] = require('partner/modules/herbal-product-specification/actions/get-cms-product-attribute.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };